import styled from 'styled-components';
import { LoadingIcon } from 'assets/icons';
import { BREAKPOINTS } from 'constants/common';

const SuccessBlock: React.VFC = () => {
  return (
    <SuccessBlockWrapper data-testid="successBlock">
      <Group>
        <Text3>Payment successful!</Text3>
        <Text1>You’re being redirected to the Sked Dashboard.</Text1>
        <Loading>
          <LoadingIcon />
        </Loading>
        <Text2 href="/">Or click here</Text2>
      </Group>
    </SuccessBlockWrapper>
  );
};

export default SuccessBlock;

const SuccessBlockWrapper = styled.div`
  height: 452px;
  width: 358px;
  border-radius: 5px;

  background-color: var(--greenLightBackground);
  display: flex;
  @media (min-width: ${BREAKPOINTS.maxTablet}px) {
    width: 100%;
  }
  @media (min-width: ${BREAKPOINTS.maxDesktop}px) {
    width: 100%;
  }
`;

const Group = styled.div`
  margin: auto;
`;

const Text1 = styled.div`
  text-align: center;
  vertical-align: top;
  font-size: 14px;
  line-height: auto;
  color: var(--black);
  margin-bottom: 32px;
  width: 255px;
`;

const Text2 = styled.a`
  display: block;
  text-align: center;
  font-size: 14px;
  line-height: auto;
  text-decoration: underline;
  color: var(--primary);
`;

const Text3 = styled.div`
  text-align: center;
  vertical-align: top;
  font-size: 24px;
  line-height: auto;
  color: var(--black);
  margin-bottom: 32px;
  font-weight: 600;
`;

const Loading = styled.div`
  height: 98px;
  width: 98px;
  margin: auto;
  margin-bottom: 35px;
  animation: spin 4s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
